var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.9999V19C15 20.1046 14.1046 21 13 21H5C3.89543 21 3 20.1046 3 19V10.9999C3 9.89538 3.89538 8.99996 4.99992 8.99992L6 8.99988M15 9V6.5M15 9V11.5M15 9H12.5M15 9H17.5M11 2.99988H19C20.1046 2.99988 21 3.89531 21 4.99988V12.9999C21 14.1044 20.1046 14.9999 19 14.9999H11C9.89543 14.9999 9 14.1044 9 12.9999V4.99988C9 3.89531 9.89543 2.99988 11 2.99988Z",
    stroke: "#675D75",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d4af2dcf2b85ca8ace8ba9d227656a5b.svg";
export { ForwardRef as ReactComponent };